export const styles = (theme) => ({
  paper: {
    width: '100%',
    maxWidth: 570,
    padding: '20px 25px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  label: {
    display: 'block',
    '& > *:first-child': {
      marginBottom: theme.spacing(1),
    },
  },
  buttonHolder: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  button: {
    margin: 20,
    minWidth: 100,
  },
  verticalDivider: {
    width: 1,
    height: 30,
    backgroundColor: theme.palette.borderColor.primary,
  },
});
